import { render, staticRenderFns } from "./AiAnnotationUi.vue?vue&type=template&id=10808f4f&scoped=true&"
import script from "./AiAnnotationUi.vue?vue&type=script&lang=ts&"
export * from "./AiAnnotationUi.vue?vue&type=script&lang=ts&"
import style0 from "./AiAnnotationUi.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AiAnnotationUi.vue?vue&type=style&index=1&id=10808f4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10808f4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/billylam/Code/EP/ep-web-tiptap/demo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10808f4f')) {
      api.createRecord('10808f4f', component.options)
    } else {
      api.reload('10808f4f', component.options)
    }
    module.hot.accept("./AiAnnotationUi.vue?vue&type=template&id=10808f4f&scoped=true&", function () {
      api.rerender('10808f4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiAnnotationUi/AiAnnotationUi.vue"
export default component.exports